import request from '@/plugins/request'

export function getKeywordList(key, parids, pageindex, pagesize) {
    return request({
        url: '/v1/KeyWord/GetKeyWordList',
        method: 'post',
        data: {
            key: key,
            parIds: parids,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}

export function keywordEdit(id, keyword, state) {
    return request({
        url: '/v1/KeyWord/KeyWordEdit',
        method: 'post',
        data: {
            id: id,
            keyword: keyword,
            state: state
        }
    })
}

export function keywordDel(id) {
    return request({
        url: '/v1/KeyWord/KeyWordDel',
        method: 'post',
        data: {
            id: id
        }
    })
}
export function keywordRelRebuild(id, typeids) {
    return request({
        url: '/v1/KeyWord/KeyWordRelRebuild',
        method: 'post',
        data: {
            id: id,
            typeIds: typeids
        }
    })
}
export function getKeyWordFluByKeyWord(id) {
    return request({
        url: '/v1/KeyWord/GetKeyWordFluByKeyWord',
        method: 'post',
        data: {
            keyid: id,
        }
    })
}

export function getKeywordById(id) {
    return request({
        url: '/v1/KeyWord/GetKeyWordById',
        method: 'post',
        data: {
            id: id,
        }
    })
}
export function getUserLastAddKeyWordList() {
    return request({
        url: '/v1/KeyWord/GetUserLastAddKeyWordList',
        method: 'post',
    })
}

